import { Grid } from "@mui/material";
import React, { Fragment } from "react";
import { IGridFormControlProps } from "src/Shared/Interfaces/IGridFormControlProps.interface";
import ViewInputControl from "../ViewInputControl/ViewInputControl";

const GridFormControl: React.FC<IGridFormControlProps> = (props) => {
  const { inputControls, row, col, spacing, form, itemResponsive } = props;

  /**
   * Lays the visible controls out in a grid.
   *
   * The row count follows the number of controls rather than the configured grid. It used to be
   * taken from the configuration alone, so any form with more controls than row x col slots had the
   * remainder silently discarded — the contact dialog rendered 8 of its 15 controls, which dropped
   * the required TDDA/Health Tick field and left the form permanently invalid with no way to see
   * why (bugs 5674, 5682, 5694). A layout setting must never be able to remove a field the form
   * still validates on.
   *
   * The configured column count and the control order are unchanged, so every existing layout looks
   * the same; forms that were dropping controls simply gain the rows they always needed.
   */
  const genrateGrid = (rows, cols) => {
    const visible = inputControls.filter((x) => !x.hidden);
    const columns = Math.max(1, cols);
    const rowCount = Math.max(rows, Math.ceil(visible.length / columns));

    return Array.from({ length: rowCount }, (_, rowIndex) =>
      Array.from(
        { length: columns },
        (_, colIndex) => visible[rowIndex * columns + colIndex] || null
      )
    );
  };

  return (
    <div>
      {genrateGrid(col, row).map((value, index) => (
        <Grid
          container
          justifyContent=""
          alignItems="center"
          spacing={spacing}
          key={index}
        >
          {value.map((control, index) => {
            return (
              <Grid item {...itemResponsive} key={index}>
                {control && !control.hidden && (
                  <ViewInputControl form={form} {...control} />
                )}
              </Grid>
            );
          })}
        </Grid>
      ))}
    </div>
  );
};

export default GridFormControl;
